import React from "react";
import dayjs from "dayjs";

export default ({ title, value, isHeading }) => {
  return (
    <>
      {isHeading ? (
        <div className="row">
          <h4>
            {title + ": "}
            <time dateTime={value}>{dayjs(value).format("MM/DD/YYYY")}</time>
          </h4>
        </div>
      ) : (
        <div className="row">
          <div className="name">{title}:</div>
          <time dateTime={value}>{dayjs(value).format("MM/DD/YYYY")}</time>
        </div>
      )}
    </>
  );
};
